import { Injectable } from '@angular/core';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { Map } from '../../models/objects.model';
import { saveAs } from 'file-saver';
import {
  FunctionDesc,
  ElementAction,
  CustomAction,
  RestServiceAction,
  ParameterAction,
  AssemblyAction
} from '../../models/configuration.model';
import { DialogControllerService } from '../dialog-controller/dialog-controller.service';
import { AuthService } from '../../auth/services/auth/auth.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NotificationService } from '../notification/notification.service';
import { FunctionStoreService } from '../function-store/function-store.service';
import { LoadingControllerService } from '../loading-controller/loading-controller.service';
import { CustomService } from '../custom/custom.service';

// TODO MK-REF
@Injectable()
export class FunctionService {
  elementViewId = '';
  elementId = '';
  currentId = '';
  specialFunctions: string[] = ['dodaj_zawiadomienie', 'pobierz_zawiadomienie'];

  constructor(
    private bafAgent: BafAgentService,
    private dialogController: DialogControllerService,
    private storeService: DataStoreService,
    private functionStore: FunctionStoreService,
    private authService: AuthService,
    private userService: UserProfileService,
    private notifier: NotificationService,
    private loadingService: LoadingControllerService,
    private customService: CustomService
  ) {}

  callFunction(functionName: any, currentId: any, obj: FunctionDesc) {
    const elementAction: ElementAction = obj.action as ElementAction;
    if (elementAction == null) {
      return;
    }
    switch (elementAction.actionType) {
      case 'LogoutAction':
        this.authService.logout();
        return;
      case 'CustomAction':
        if (!this[functionName]) {
          throw new Error(
            'Brak implementacji funkcji ' + functionName + ' typu ' + elementAction.actionType
          );
        }
        this[functionName](currentId);
        return;
      case 'ElementAction':
        if (!this[functionName]) {
          throw new Error(
            'Brak implementacji funkcji ' + functionName + ' typu ' + elementAction.actionType
          );
        }
        this[functionName](currentId, elementAction);
        return;
      default:
        throw new Error(
          'Brak implementacji funkcji ' + functionName + ' typu ' + elementAction.actionType
        );
    }
  }

  callParameterized(action: ParameterAction, id: string) {
    const parameters = {
      destParameterAttributeId: action.destParameterAttributeId,
      destinationAttributeId: action.destinationAttributeId,
      destinationElementId: action.destinationElementId,
      id: action.id,
      parameterActionType: action.parameterActionType,
      parameterType: action.parameterType,
      sourceValue: id
    };

    this.bafAgent.executeParameterizedAction(parameters).subscribe(data => {
      this.functionStore.refreshFunctions();
      this.storeService.refreshNode();
    });
  }

  callService(action: RestServiceAction, id: string) {
    let url = action.serviceUrl;

    for (const parameter of action.parameters) {
      const value = this.storeService.currentRowData.value[parameter.sourceAttributeViewId];
      url += `&${parameter.parameterName}=${value}`;
    }

    this.bafAgent.downloadResource(url);
  }

  saveFile(action: AssemblyAction, data, rowData) {
    var prefix = this.customService.getType();
    var fileName = !prefix ? this.storeService.currentId : prefix + '_' + this.storeService.currentId;
    if (action.headerMediaReturnType === 'application/pdf') {
      const blob = new Blob([data], { type: action.headerMediaReturnType });
      saveAs(blob, fileName + '.pdf');
    } else {
      saveAs(data, fileName + '.zip');
    }
    this.loadingService.hide();
  }

  assemblyActionCallback(action: AssemblyAction, content){
    this.loadingService.hide();
    action.headerMediaReturnType == null ? this.refreshAfterAction(content) : this.storeService.setCustomSingleViewContent(content);    
  }

  callAssemblyAction(action: AssemblyAction, id: string, fun: FunctionDesc, rowData) {
    this.loadingService.show(fun.displayName.name);
    const form = new FormData();
    form.append('assemblyAction', JSON.stringify(action));
    form.append('data', this.storeService.currentId);
    if (action.returnType === 'System.IO.FileStream') {
      this.bafAgent.executeAssemblyAction(form, { responseType: 'blob' as 'json' }).subscribe(
        data => this.saveFile(action, data, rowData),
        error => this.showError('Problem z przygotowaniem pliku.')
      );
    } else {
      this.bafAgent.executeAssemblyAction(form, {}).subscribe(
          content => this.assemblyActionCallback(action, content),
          error => this.showError(error.error.Message)
        );
    }
  }

  refreshAfterAction(message: string): void {
    this.loadingService.hide();
    this.notifier.success(message);
    this.functionStore.refreshFunctions();
    this.storeService.refreshNode();
  }

  showError(message: string): void {
    this.loadingService.hide();
    this.notifier.error(message);
  }

  save(map: Map, currentId: number) {
    this.bafAgent
      .saveData(
        this.storeService.currentElementId,
        this.storeService.currentElementViewId,
        currentId,
        JSON.stringify(map)
      )
      .subscribe(() => {
        this.functionStore.refreshFunctions();
        this.storeService.refreshNode();
      });
  }

  checkAllowFunction(func: FunctionDesc): boolean {
    const customAction = func.action as CustomAction;
    if (
      customAction.actionType === 'AssemblyAction' ||
      customAction.actionType === 'RestServiceAction' ||
      customAction.actionType === 'ParameterAction'
    ) {
      return true;
    }

    return false;
  }

  getCurrentStatus(m: Map[]): string {
    const s: string = m[this.storeService.currentObjectId + '_ZAWIADOMIENIA-STATUS'];
    return s;
  }

  callCustomFunction(functionName: any, obj: FunctionDesc) {
    this[functionName]();
    this.functionStore.refreshFunctions();
    this.storeService.refreshNode();
  }

  wyczysc_profil() {
    this.userService.clear();
  }

  pobierz_pomoc() {
    window.open(this.storeService.apiUrl + 'Help/WAKB_pomoc.pdf');
  }

  o_aplikacji() {
    this.dialogController.openAboutDialog();
  }

  dodaj_certyfikat() {
    this.dialogController.openCertDialog();
  }

  profil_uzytkownika() {
    this.dialogController.openUserProfileDialog();
  }

  dodaj_zawiadomienie(currentId, action) {
    this.storeService.currentElementId = action.elementId;
    this.storeService.currentElementViewId = action.elementViewId;

    this.storeService.setShowGrid(false);
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return <File>theBlob;
  };
}



// WEBPACK FOOTER //
// ./src/app/services/function/function.service.ts